<script lang="ts">
    import {_} from 'svelte-i18n'
    import Button from '@smui/button';
    import {Label} from '@smui/common';
    import type {DefinedMessage} from './types';
    import MessageInput from './MessageInput.svelte';
    import {createEventDispatcher} from 'svelte';
    import OtherContextInfo from './OtherContextInfo.svelte';

    export let definedMessage: DefinedMessage;

    const dispatch = createEventDispatcher();
    let definedMessageText: string = definedMessage.text;
    let definedMessageValid: boolean = false;
    let modificationSaved: boolean = true;

    $: modificationSaved = definedMessage.text === definedMessageText;

    async function submit() {
        definedMessage.text = definedMessageText;
        await save();
    }

    function save() {
        dispatch('save', definedMessage);
    }

    function remove() {
        dispatch('remove', definedMessage);
    }
</script>

<form on:submit|preventDefault={submit} style="display: flex; flex-direction: row;">
    <div>
        <OtherContextInfo entity={definedMessage} />
    </div>

    <MessageInput bind:value={definedMessageText} bind:valueValid={definedMessageValid} on:message-submit={submit} />

    <div style="min-width: 160px; text-align: right;">
        <Button type="submit" disabled={modificationSaved} variant="unelevated">
            <Label>
                {#if modificationSaved}
                    {$_('commons.Saved')}
                {:else}
                    {$_('commons.Save')}
                {/if}
            </Label>
        </Button>
        <Button type="button" on:click={remove} variant="unelevated">
            <Label>{$_('commons.Delete')}</Label>
        </Button>
    </div>
</form>